export const PERFIOS_COMPLETE_START = "PERFIOS_COMPLETE_START"
export const PERFIOS_COMPLETE_SUCCESS = "PERFIOS_COMPLETE_SUCCESS"
export const PERFIOS_COMPLETE_ERROR = "PERFIOS_COMPLETE_ERROR"
export const PERFIOS_COMPLETE_RESET = "PERFIOS_COMPLETE_RESET"